import ArchitectsSidebarContent from "components/Architects/ArchitectsSidebarContent";
import SEO from "components/Seo";
import { architectsTranslations } from "constants/architectsTranslation";
import useHeaderTitleSetter from "customHooks/useHeaderTitleSetter";
import useTranslation from "next-translate/useTranslation";
import CustomBreadCrumbs from "../components/ReuseableCompos/CustomBreadCrumbs";
import CustomJumbotron from "../components/ReuseableCompos/CustomJumbotron";
const ArchitectsLayout = ({ children }) => {
  const { t } = useTranslation("common");
  useHeaderTitleSetter({
    title: t(architectsTranslations.jumbotron.title),
  });
  return (
    <>
      <SEO
        title={t(architectsTranslations.jumbotron.title)}
        description={t(architectsTranslations.jumbotron.desc)}
      />
      <div className="cs-sidebar-enabled pt-2 pt-sm-0 h-100">
        <div className="container-fluid px-0 container-md px-md-4 overflow-hidden h-100">
          <div className="row h-100">
            <ArchitectsSidebarContent />
            <div className="col-lg-9 cs-content pt-lg-0">
              <div className="d-flex align-items-center">
                <CustomJumbotron
                  m="mt-0 mb-4"
                  p="py-4 px-0"
                  breadCrumbM="my-0"
                  className="mt-0 border-bottom"
                  title={t(architectsTranslations.jumbotron.title)}
                  desc={t(architectsTranslations.jumbotron.desc)}
                  customBreadCrumbs={
                    <CustomBreadCrumbs
                      transformedLabel={() =>
                        t(architectsTranslations.jumbotron.title)
                      }
                    />
                  }
                />
              </div>
              <div className="container px-3 px-md-0"> {children}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ArchitectsLayout;
